/** Expand all / Collapse all over every group of a clause list: a signal each group
 * follows when it changes, and takes as its starting state when it mounts later. */
import { createContext, useContext } from "react";

export interface CollapseSignal {
  open: boolean;
  /** Bumped on every press, so the same choice twice still reaches every group. */
  n: number;
}

export const CollapseContext = createContext<CollapseSignal | null>(null);

export const useCollapseSignal = (): CollapseSignal | null => useContext(CollapseContext);
